export const getUserMenuFragmentEventInfo = textContent => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: `my account:${textContent}`,
    eventMsg: "n/a",
    eventName: `my account:${textContent}`,
    eventStatus: "n/a",
    eventType: "global header",
    internalLinkName: textContent,
    internalLinkPosition: `global header:${textContent}`,
    internalLinkType: "global header:navigation",
    internalLinkURL: "n/a",
    internalLinkZoneName: "global header",
  })
}
